import {utilGenerate} from 'bit-util'

const map = utilGenerate({});

export default map
